import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useUnit} from 'effector-react';
import {$groupsForPerms} from '../../models/adminModel/index.js';
import {$user} from '../../models/authModel/index.js';
import {Link, useNavigate} from 'react-router-dom';
import {PanelMenu} from 'primereact/panelmenu';
import {Sidebar} from 'primereact/sidebar';
import {Button} from 'primereact/button';
import {Image} from 'primereact/image';
import img from '../../assets/logo.png'
import checkGroupPerm from '../../utils/checkGroupPerm.js';

export default function NavSideBar() {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const [visible, setVisible] = useState(false);

    const perms = useUnit($groupsForPerms)
    const user = useUnit($user)

    const onSelect = (url) => {
        setVisible(false)
        navigate(url)
    }

    const menuItems = [
        {
            icon: 'pi pi-inbox',
            label: t('Мои заявки'),
            visible: checkGroupPerm(perms, user, '/requests/my-applications'),
            command: () => onSelect('/requests/my-applications')
        },
        {
            label: t('Обучение'),
            icon: 'pi pi-pencil',
            items: [
                {
                    label: t('Пройденные курсы'),
                    icon: 'pi pi-list-check',
                    visible: checkGroupPerm(perms, user, '/completed-courses'),
                    command: () => onSelect('/completed-courses')
                },
                {
                    label: t('Мои сертификаты'),
                    icon: 'pi pi-file-check',
                    visible: checkGroupPerm(perms, user, '/my-certificates'),
                    command: () => onSelect('/my-certificates')
                },
            ]
        },
        {
            label: t('Актуальное для бизнеса'),
            visible: checkGroupPerm(perms, user, '/for-business'),
            icon: 'pi pi-chart-bar'
        },
        {
            label: t('Аналитика'),
            icon: 'pi pi-chart-scatter',
            visible: checkGroupPerm(perms, user, '/analytics'),
            command: () => onSelect('/analytics')
        },
        {
            label: t('Заявки'),
            icon: 'pi pi-book',
            items: [
                {
                    label: t('Сертификаты'),
                    visible: checkGroupPerm(perms, user, '/requests/certificates'),
                    command: () => onSelect('/requests/certificates')
                },
                {
                    label: t('Площадки для производственных предприятий'),
                    visible: checkGroupPerm(perms, user, '/requests/industrial-sites'),
                    command: () => onSelect('/requests/industrial-sites')
                },
                {
                    label: t('Реестр инвест проектов'),
                    visible: checkGroupPerm(perms, user, '/requests/invest-registry'),
                    command: () => onSelect('/requests/invest-registry')
                },
                {
                    label: t('КТА'),
                    visible: checkGroupPerm(perms, user, '/requests/kta'),
                    command: () => onSelect('/requests/kta')
                },
                {
                    label: t('Консультации'),
                    visible: checkGroupPerm(perms, user, '/requests/consulting'),
                    command: () => onSelect('/requests/consulting')
                },
            ]
        },
        {
            label: t('Статистика'),
            icon: 'pi pi-chart-pie'
        },
        {
            label: t('Аналитика предпринимательства'),
            visible: checkGroupPerm(perms, user, '/analytics'),
            icon: 'pi pi-chart-line',
            items: [
                {
                    label: t('Предпринимательство города'),
                    icon: 'pi pi-building',
                    visible: checkGroupPerm(perms, user, '/analytics/city'),
                    command: () => onSelect('/analytics/city')
                },
                {
                    label: t('Показатели МСП'),
                    icon: 'pi pi-shop',
                    visible: checkGroupPerm(perms, user, '/analytics/msp'),
                    command: () => onSelect('/analytics/msp')
                },
                {
                    label: t('Приоритетные отрасли'),
                    icon: 'pi pi-angle-double-up',
                    items: [
                        {
                            label: t('Креативные индустрии'),
                            visible: checkGroupPerm(perms, user, '/analytics/creative'),
                            command: () => onSelect('/analytics/creative')
                        },
                        {
                            label: t('Обрабатывающая промышленность'),
                            visible: checkGroupPerm(perms, user, '/analytics/processing'),
                            command: () => onSelect('/analytics/processing')
                        },
                        {
                            label: t('Туризм'),
                            visible: checkGroupPerm(perms, user, '/analytics/tourism'),
                            command: () => onSelect('/analytics/tourism')
                        },
                    ]
                },
                {
                    label: t('Рейтинг деловой климат'),
                    icon: 'pi pi-briefcase',
                    visible: checkGroupPerm(perms, user, '/analytics/climate'),
                    command: () => onSelect('/analytics/climate')
                },
                {
                    label: t('ABC индекс'),
                    icon: 'pi pi-objects-column',
                    items: [
                        {label: t('Основные показатели')},
                        {label: t('Итоги опросов')}
                    ]
                }
            ]
        },
        {
            label: t('Цифровая карта'),
            icon: 'pi pi-globe',
            items: [
                {
                    label: t('Предпринимательство города (3D)'),
                    icon: 'pi pi-box',
                    command: () => onSelect('/geo/city')
                },
                {
                    label: t('Производственные площадки'),
                    icon: 'pi pi-hammer',
                    command: () => onSelect('/geo/manufacturers')
                },
                {
                    label: t('Инфраструктура креативных индустрий'),
                    icon: 'pi pi-lightbulb',
                    command: () => onSelect('/geo/creative')
                },
            ]
        },
        {
            label: t('Запросы бизнеса'),
            icon: 'pi pi-address-book',
            items: [
                {label: t('Реестр заявок'), icon: 'pi pi-database'},
                {
                    label: t('Отчеты'),
                    icon: 'pi pi-file-check',
                    items: [
                        {label: t('Промпарки и ИЗА'), icon: 'pi pi-warehouse'},
                        {label: t('Креативные хабы'), icon: 'pi pi-sparkles'},
                        {label: t('Консультации'), icon: 'pi pi-users', items: [{label: t('Отчет 1')}]},
                        {label: t('Обучение'), icon: 'pi pi-graduation-cap'},
                        {label: t('Финансирование'), icon: 'pi pi-money-bill'}
                    ]
                }
            ]
        },
        {
            label: t('Мой профиль'),
            icon: 'pi pi-user',
            command: () => onSelect('/my-profile')
        },
        {
            label: t('Пользователи'),
            icon: 'pi pi-user-edit',
            visible: checkGroupPerm(perms, user, '/admin/users'),
            command: () => onSelect('/admin/users')
        }
    ]

    return <div className={'card flex align-items-start h-full max-w-fit'}
                onMouseEnter={() => setVisible(true)}
    >
        <Sidebar header={<Link to={'/'}><Image src={img}/></Link>}
                 visible={visible}
                 onHide={() => setVisible(false)}
                 className={'w-30rem'}
                 pt={{mask: {style: {animation: 'none'}}}}
        >
            <PanelMenu model={menuItems} pt={
                {
                    headerAction: {
                        style: {padding: '.6rem', background: 'transparent'},
                        className: 'hover:text-primary'
                    },
                    headerContent: {
                        style: {background: 'transparent', border: 'none'}
                    },
                    menuContent: {style: {border: 'none'}},
                    label: {
                        className: 'hover:text-primary'
                    },
                }
            }/>
        </Sidebar>
        <Button className={'p-button-text'}
                icon={'pi pi-bars'}
                size={'large'}
                onClick={() => setVisible(true)}
        />
    </div>
}